var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.formLink}},[_c('div',{staticClass:"white__v-btn mb-4 card"},[_c('v-icon',{staticClass:"icon",attrs:{"size":"25"}},[_vm._v("mdi-filter-outline")]),_c('span',[_vm._v(_vm._s(_vm.form.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }